export const TableReload = (id, withCache = false) => ({
    type: 'TableReload',
    id: id,
    withCache: withCache
});
